export enum ValidationMessages {
  EXISTING_EMAIL = 'User with this email already exists',
  CHECKING_EMAIL_UNIQUENESS = 'Checking for existing user',
}
